import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getBgMaster } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetBgMasterRequestSchema,
  type GetBgMasterResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * BG マスタ full entity 取得 hook。
 * members を含む全フィールドを返す。Edit modal の form initial value に使用する。
 * id が undefined または空文字の場合は query を無効化する。
 */
export function useGetBgMaster(
  id: string | undefined,
): UseQueryResult<GetBgMasterResponse, ConnectError> {
  return useQuery(
    getBgMaster,
    create(GetBgMasterRequestSchema, { id: id ?? '' }),
    { enabled: id !== undefined && id !== '' },
  )
}
